import { IconService } from './../../../services/icon.service';
import { IdentityDocument } from './../../../models/Profile/CustomerSummaryModel';
import { BookingService } from 'src/app/services/booking.service';
import { Customer } from './../../../models/Customer';
import { CustomerSummaryModel } from 'src/app/models/Profile/CustomerSummaryModel';
import { SearchService } from 'src/app/services/search.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { GenderEnum } from 'src/app/models/enums/Customer/CustomerEnum'
import { CountryISO, SearchCountryField, TooltipLabel } from 'ngx-intl-tel-input';
import { LocationLevel, LocationModel } from 'src/app/models/Location/LocationModel';
import { NationalitieModel } from 'src/app/models/Profile/NationalitieModel';
import { AttachmentUploadModel } from 'src/app/models/Attachment/AttachmentUploadModel';
import { AttachmentService } from 'src/app/services/attachment.service';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { AttachmentModelResult } from 'src/app/models/Attachment/AttachmnetModel';
import { $ } from 'protractor';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { Subscription } from 'rxjs';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import 'moment/locale/ar';
import { DatePipe } from '@angular/common';

export interface EditUserDto {

  Type: string;
  Number: string;
  ExpiresDate: string;
  Attached: string;

}

export interface EditUser {
  currentData?: EditUserDto;
  originalData: EditUserDto;
  editable: boolean;
  validator: FormGroup;
}
export interface ExistAttachmentID {
  TypeID?: AttachmentTypeEnum, AttachmnetID?: string
}


@Component({
  selector: 'edit-my-profile',
  templateUrl: './edit-my-profile.component.html',
  styleUrls: ['./edit-my-profile.component.css'],
  providers: [
    DatePipe ,
    {provide: MAT_DATE_LOCALE, useValue: 'en-US'},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ],
})
export class EditMyProfileComponent implements OnInit,OnDestroy {
  selectedLang: any;
  faTimesCircle = faTimesCircle;
  @Input() customerProfile: CustomerSummaryModel;
  @Input() profilePicAttachmnetID;
  @Input() identityAttachmnetModel: AttachmentModelResult;
  @Output() onCancel = new EventEmitter();
  currency;
  isSubmitted = false;
  personalInfoForm: FormGroup;
  occupation;
  nationalty;
  country;
  selectedCountryISO = CountryISO.UnitedStates;
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });
  emailOldVal: any;
  currentCustomerEmail: string;
  locationsRoot: LocationModel[];
  locationLevels: LocationLevel[];
  selectedLevels = {};
  selectedRoot: LocationModel;
  nationalities: NationalitieModel;
  attachmentIds = {}; //Dictionary:Control Name as a Key and Atatchment obj as a Value
  existAttachmentIDs: ExistAttachmentID[];
  attachmentDeleteIds = [];
  idCardControlName = 'idCard';
  passportControlName = 'passport';
  driverLincesControlName = "drivingLicense";
  minDOB: Date = new Date();
  subscriptions: Subscription[] = [];

  get locationLevelsDropDown() {
    if (this.locationLevels == null)
      return null
    return this.locationLevels.filter(a => a.isRootLevel != true);
  }
  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum() {

    return AttachmentTypeEnum;
  }

  changePreferredCountries() {
    this.preferredCountries = [CountryISO.India, CountryISO.Canada];
  }


  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private dialog: MatDialog,
    private authService: AuthService,
    private searchService: SearchService,
    private bookingService: BookingService,
    private attachmentService: AttachmentService,
    private iconService: IconService,
    private el: ElementRef,
    private _adapter: DateAdapter<any>,
    private datePipe: DatePipe
  ) {
    this.matIconRegistry.addSvgIcon(
      "champions-icon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.championsIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "booking-icon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.bookingIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "payment-icon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.paymentIcon)
    );
    //this.customerProfile = auth.getCustomerProfile();
    this.currency = searchService.getCurrency();


  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
  }


  onSubmit() {




  }

  onReset() {
    this.onCancel.emit(false);
    this.personalInfoForm.reset();
  }

  ELEMENT_DATA_FROM_BACK: EditUserDto[] = [];

  ELEMENT_DATA: EditUser[] = [];

  displayedColumns: string[] = ['Type', 'Number', 'ExpiresDate', 'Attached'];
  dataSource: MatTableDataSource<EditUser>;
  selected = 'option1';
  customer: Customer;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  editForm: FormGroup;


  get genderEnum(): typeof GenderEnum {
    return GenderEnum;
  }

  getAttachment(controlName, fileName, scopeID, typeID) {
    let _attachment = this.identityAttachmnetModel.attachmentModel.filter(a => a.attachmentTypeID == typeID)[0];
    if (_attachment != null) {
      this.personalInfoForm.controls[controlName].setValue(_attachment.attachmentURL);
      this.personalInfoForm.controls[fileName].setValue(_attachment.attachmentsName);
    }

    /*   this.attachmentService.imageHandler(this.customer.customerID, scopeID, typeID).subscribe(res => {
        this.personalInfoForm.controls[controlName].setValue(res['result']);


      }) */
  }

  fillIDentityDataTable() {

    if (this.customerProfile.identityDocument != null) {
      let identity = this.customerProfile.identityDocument;
      if (identity.driverLicenseNumber != null && identity.driverLicenseExpiryDate != null) {
        this.personalInfoForm.controls.drivingLicense.setValue(identity.driverLicenseNumber);
        this.personalInfoForm.controls.drivingLicenseExpireDate.setValue(identity.driverLicenseExpiryDate);
        this.getAttachment('drivingLicenseAttachmentLink', 'drivingLicenseFileName', AttachmentScopesEnum.Customer, AttachmentTypeEnum.DrivingLicense);

        this.ELEMENT_DATA_FROM_BACK.push(
          { Type: 'National Driving License', Number: identity.driverLicenseNumber, ExpiresDate: identity.driverLicenseExpiryDateFormated, Attached: 'Driving Licenese', }
        )
      }
      if (identity.passportNumber != null && identity.passportExpiryDate != null) {
        this.personalInfoForm.controls.passport.setValue(identity.passportNumber);
        this.personalInfoForm.controls.passportExpireDate.setValue(identity.passportExpiryDate);
        this.getAttachment('passportAttachmentLink', 'passportFileName', AttachmentScopesEnum.Customer, AttachmentTypeEnum.Passport);

        this.ELEMENT_DATA_FROM_BACK.push(
          { Type: 'Passport', Number: identity.passportNumber, ExpiresDate: identity.passportExpiryDateFormated, Attached: 'Passport', }
        )
      }
      this.personalInfoForm.controls.idCard.setValue(identity.identityNumber);
      this.personalInfoForm.controls.idCardExpireDate.setValue(identity.identityExpiryDate);
      this.personalInfoForm.controls.idCardIssueDate.setValue(identity.identityIssueDate);

      this.personalInfoForm.controls.passportIssueDate.setValue(identity.passportIssueDate);
      this.personalInfoForm.controls.drivingLicenseIssueDate.setValue(identity.driverLicenseIssueDate);
      this.getAttachment('idCardAttachmentLink', 'idCardFileName', AttachmentScopesEnum.Customer, AttachmentTypeEnum.IdintityCard);


      const editForm = (e) => new FormGroup({
        Type: new FormControl(e.Type, Validators.required),
        Number: new FormControl(e.Number, Validators.required),
        ExpiresDate: new FormControl(e.ExpiresDate, Validators.required),
        Attached: new FormControl(e.Attached, Validators.required),
      });
      this.ELEMENT_DATA_FROM_BACK.forEach(element => {
        this.ELEMENT_DATA.push({
          currentData: element,
          originalData: element,
          editable: false,
          validator: editForm(element)
        });
      });
    }
  }
  ngOnInit() {


    // This is For changing language for the calendar
    this.selectedLang = JSON.parse(localStorage.getItem("lang"));
    switch (this.selectedLang.isoCode2) {
      case "en":
        this._adapter.setLocale('en-US');
        break;
      case "ar":
        this._adapter.setLocale('ar-ly');
        break;
      default: 
        this._adapter.setLocale('en-US');
        break;
    }


    this.minDOB.setFullYear(this.minDOB.getFullYear() - 18);

    this.authService.loggedInCustomer.subscribe(res => {
      this.customer = res;
    })

    this.currentCustomerEmail = this.customerProfile.primaryEmail;



    this.personalInfoForm = new FormGroup({
      firstName: new FormControl(this.customerProfile.firstName),
      secondName: new FormControl(this.customerProfile.secondName),
      thirdName: new FormControl(this.customerProfile.thirdName),
      familyName: new FormControl(this.customerProfile.familyName),


      gender: new FormControl(this.customerProfile.genderID),
      //mobileCode: new FormControl('', Validators.required),
      mobileNum: new FormControl(this.customerProfile.mobile1, Validators.required),
      //country: new FormControl(null, Validators.required),
      //city: new FormControl('', Validators.required),
      //address: new FormControl(this.customerProfile.fullAdress, Validators.required),
      DateofBirth: new FormControl(this.customerProfile.dob, Validators.required),
      email: new FormControl ({value: this.customerProfile.primaryEmail, disabled: true}, [Validators.required,
      Validators.email
      ]),
      
   
      nationalty: new FormControl(this.customerProfile.nationalityID, Validators.required),
      occupation: new FormControl(this.customerProfile.occupationID+''),
      workPlace: new FormControl(this.customerProfile.workplace),
      locationRoot: new FormControl(),
      passport: new FormControl(null),
      passportExpireDate: new FormControl(null),
      passportIssueDate: new FormControl(null),
      passportAttachmentLink: new FormControl(null),
      passportFileName: new FormControl(null),
      idCard: new FormControl(null),
      idCardExpireDate: new FormControl(null),
      idCardIssueDate: new FormControl(null),
      idCardAttachmentLink: new FormControl(null),
      idCardFileName: new FormControl(null),
      drivingLicense: new FormControl(null),
      drivingLicenseExpireDate: new FormControl(null),
      drivingLicenseIssueDate: new FormControl(null),
      drivingLicenseAttachmentLink: new FormControl(null),
      drivingLicenseFileName: new FormControl(null),

    });
    this.fillIDentityDataTable();

    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA.slice());
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    // this.searchService.getCountryCodeFromIP().subscribe(res => {

    //   if (res != null && res['countryCode'] != null) {
    //     this.selectedCountryISO = res['countryCode'];
    //   }
    // })
    this.subscriptions.push(this.authService.getCustomerLocation(null).subscribe(res => {


      this.personalInfoForm.addControl("country", new FormControl(null,Validators.required));
      this.locationsRoot = res;


      if (this.customerProfile != null && this.customerProfile.locationDetails != null) {
        let rootLevel = this.customerProfile.locationDetails.filter(a => a.isRootLevel == true)[0];
        if (rootLevel != null) {
          let result = this.locationsRoot.filter(a => a.locationID == rootLevel.locationID)[0];
          if (result != null) {
            //result.isSelected=true;

            this.selectedRoot = result;
            this.personalInfoForm.controls['country'].setValue(result);
            this.buildLocations(result);
          }
        }
      }

    }))
    this.subscriptions.push(this.authService.getNationalities().subscribe(res => {

      this.nationalities = res;
    }))
    this.identityAttachmnetModel.attachmentModel.forEach(item => {
      if (this.existAttachmentIDs == null) {
        this.existAttachmentIDs = [
          {
            TypeID: item.attachmentTypeID,
            AttachmnetID: item.attachmentID
          }];
      }
      else {
        this.existAttachmentIDs.push(
          {
            TypeID: item.attachmentTypeID,
            AttachmnetID: item.attachmentID
          }
        );
      }

    });
    /*     this.attachmentService.getIdentityAttachemnt(this.customer.customerID, AttachmentScopesEnum.Customer).subscribe(res => {

          if (res != null) {
            res.attachmentModel.forEach(item => {
              if (this.existAttachmentIDs == null) {
                this.existAttachmentIDs=[
                  {
                    TypeID: item.attachmentTypeID,
                    AttachmnetID: item.attachmentID
                  }];
              }
              else {
                this.existAttachmentIDs.push(
                  {
                    TypeID: item.attachmentTypeID,
                    AttachmnetID: item.attachmentID
                  }
                );
              }

            })
          }
        })
         */
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteRow(index: number) {
    const data = this.dataSource.data;
    data.splice((this.paginator.pageIndex * this.paginator.pageSize) + index, 1);

    this.dataSource.data = data;
  }

  confirmEditCreate(row) {
    row.editable = false;
    // save form control values to data object
    Object.keys(row.validator.controls).forEach(item => {
      row.currentData[item] = row.validator.controls[item].value;
    });
  }

  startEdit(row) {
    row.editable = true;
  }
  fetchCustomerFromForm() {
    this.customerProfile.firstName = this.personalInfoForm.controls['firstName'].value;
    this.customerProfile.secondName = this.personalInfoForm.controls['secondName'].value;
    this.customerProfile.thirdName = this.personalInfoForm.controls['thirdName'].value;
    this.customerProfile.familyName = this.personalInfoForm.controls['familyName'].value;

    this.customerProfile.genderID = this.personalInfoForm.controls['gender'].value;
    this.customerProfile.dob = this.datePipe.transform(this.personalInfoForm.controls['DateofBirth'].value, 'yyyy-MM-dd');
    this.customerProfile.mobile1 = this.personalInfoForm.controls['mobileNum'].value.number;
    this.customerProfile.primaryEmail = this.personalInfoForm.controls['email'].value;
    this.customerProfile.nationalityID = this.personalInfoForm.controls['nationalty'].value;
    this.customerProfile.workplace = this.personalInfoForm.controls['workPlace'].value;
    //BUG 3521 Add Occupation drop down data and bind the selected value id.
    if (this.personalInfoForm.controls['occupation'].value != null) {
      this.customerProfile.occupationID = Number(this.personalInfoForm.controls['occupation'].value);
    }


    let locationLevel = this.locationLevels.filter(a => a.isLastLevel == true)[0];
    if (locationLevel != null) {
      if (this.selectedLevels[locationLevel.locationLevelID] != null) {
        this.customerProfile.locationID = this.selectedLevels[locationLevel.locationLevelID].locationID;
      }

    }

    let attachmentIdList = [];
    for (let key in this.attachmentIds) {
      attachmentIdList.push(this.attachmentIds[key].attachmnetID);
    }
    attachmentIdList.push(this.profilePicAttachmnetID);
    this.customerProfile.attachmentIds = attachmentIdList.filter(a => a != null && a != "").join();

    if (this.attachmentDeleteIds != null) {
      this.customerProfile.attachmentDeleteIds = this.attachmentDeleteIds.map(a => a.AttachmnetID).join();
    }


  }
  fetchIdentityDocumentFromForm() {
    let identity: IdentityDocument = {
      identityNumber: this.personalInfoForm.controls['idCard'].value,
      identityExpiryDate: this.datePipe.transform(this.personalInfoForm.controls['idCardExpireDate'].value, 'yyyy-MM-dd'),
      identityIssueDate: this.datePipe.transform(this.personalInfoForm.controls['idCardIssueDate'].value, 'yyyy-MM-dd'),
      passportNumber: this.personalInfoForm.controls['passport'].value,
      passportExpiryDate: this.datePipe.transform(this.personalInfoForm.controls['passportExpireDate'].value, 'yyyy-MM-dd'),
      passportIssueDate: this.datePipe.transform(this.personalInfoForm.controls['passportIssueDate'].value, 'yyyy-MM-dd'),
      driverLicenseNumber: this.personalInfoForm.controls['drivingLicense'].value,
      driverLicenseExpiryDate: this.datePipe.transform(this.personalInfoForm.controls['drivingLicenseExpireDate'].value, 'yyyy-MM-dd'),
      driverLicenseIssueDate: this.datePipe.transform(this.personalInfoForm.controls['drivingLicenseIssueDate'].value, 'yyyy-MM-dd'),
    }
    this.customerProfile.identityDocument = identity;

  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }


  save() {



    this.isSubmitted = true;


    this.personalInfoForm.controls.mobileNum.setErrors({'InvalidSpace':null});
    this.personalInfoForm.controls.mobileNum.setErrors({'RequiredCountryCode':null});
    this.personalInfoForm.controls.mobileNum.updateValueAndValidity();


     //custom Validation for Mobile number, Incase it have spaces
     let countryControlVal=this.personalInfoForm.controls.mobileNum.value;
     if(countryControlVal!=null&&countryControlVal.number.includes(' ')){
         this.personalInfoForm.controls.mobileNum.setErrors({'InvalidSpace':'invalidPhoneNumber'});
         //this.driverInfoForm.controls.mobileNum.updateValueAndValidity();
         return;
     }
     if(countryControlVal!=null&&!countryControlVal.number.includes(countryControlVal.dialCode)){
       this.personalInfoForm.controls.mobileNum.setErrors({'RequiredCountryCode':'invalidPhoneNumber'});
       //this.driverInfoForm.controls.mobileNum.updateValueAndValidity();
       return;
     }

    if (this.personalInfoForm.invalid) {
      this.validateAllFormFields(this.personalInfoForm);
    }







    if (this.personalInfoForm.invalid) {
      //As This bug , scroll to element that invalid
      //https://dev.azure.com/GCU365/GCU365_SAAS/_queries/edit/3556/?triage=true
      const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');

      if (invalidControl) {
        invalidControl.focus();
        invalidControl.scrollIntoView();
      }
      // const controls = this.personalInfoForm.controls;
      //   for (const name in controls) {
      //       if (controls[name].invalid) {
      //         let el = document.getElementById(name);
      //         el.scrollIntoView();
      //         return;
      //         // $("#"+name).anim
      //       }
      //   }
      return
    }
    this.fetchCustomerFromForm();
    this.fetchIdentityDocumentFromForm();


    this.bookingService.updateCustomer(this.customerProfile).subscribe(res => {
      this.onCancel.emit(true);
    })
  }

  mobileNumCountryCodeChanged(){
    this.personalInfoForm.controls['mobileNum'].setValue(null);
  }

  /*
    emilBlur(event) {

      let val = event.target.value;
      if (val.trim() == this.currentCustomerEmail) {
        return
      }
      if (val != null && val != "" && val != this.emailOldVal) {
        this.emailOldVal = val;
        this.authService.checkIfEmailExist(val).subscribe(res => {

          if (res) {
            this.personalInfoForm.controls['email']?.setErrors({ 'exist': 'Email Already Exist' });
          }
          else {
            this.personalInfoForm.controls['email']?.setErrors({ 'exist': null });
          }
        })

      }
    } */
  emilBlur(event) {

    let val = event.target.value
    if (val != null && val != "" && val != this.customer.primaryEmail) {
      val = (val as string).trim();
      let errors = this.personalInfoForm.controls['email'].errors;
      if (errors == null) {

        this.emailOldVal = val;
        this.subscriptions.push(this.authService.checkIfEmailExist(val).subscribe(res => {

          if (res) {
            this.personalInfoForm.controls['email']?.setErrors({ 'exist': 'Email Already Exist' });
          }
          else {
            this.personalInfoForm.controls['email']?.setErrors(null);
          }
        }))

      }
    }

  }
  buildLocations(locations: LocationModel) {


    //Remove the old Drop Downs Form Control data
    if(this.locationLevels!=null){
      let subLocations=this.locationLevels.filter(a => !a.isRootLevel);
      subLocations.forEach(element => {
        this.personalInfoForm.removeControl(element.locationLevelID.toString());
      });
    }

    this.locationLevels = locations.locationLevel;

    //Create new Drop Downs Form Control for the new data
    let subLocations=this.locationLevels.filter(a => !a.isRootLevel);
    subLocations.forEach(element => {
      this.personalInfoForm.addControl(element.locationLevelID.toString(),new FormControl(null,Validators.required));
    });

    let rootLocationID = this.locationLevels.filter(a => a.isRootLevel == true)[0];
    let childLevel = this.locationLevels.filter(a => a.parentID == rootLocationID.locationLevelID)[0];
    this.subscriptions.push(this.authService.getCustomerLocation(locations.locationID).subscribe(res => {
      childLevel.locationLevelData = res;
      childLevel.locationLevelData.forEach(item => {

        if (this.isLocationDropDownSelected(item)) {
          item.isSelected = true;
          this.selectedLevels[item.locationLevelID] = item;
          this.personalInfoForm.controls[item.locationLevelID+''].setValue(item);
          this.getLocationLevelDynamic(item);
        }
      })
    }));

  }
  getLocationLevelDynamic(location: LocationModel) {


    this.clearChildLevelsData(location);
    let childLevel = this.locationLevels.filter(a => a.parentID == location.locationLevelID)[0];
    if (childLevel != null) {
      this.subscriptions.push(this.authService.getCustomerLocation(location.locationID).subscribe(res => {
        childLevel.locationLevelData = res;
        childLevel.locationLevelData.forEach(item => {

          if (this.isLocationDropDownSelected(item)) {
            item.isSelected = true;
            this.selectedLevels[item.locationLevelID] = item;
            this.personalInfoForm.controls[item.locationLevelID+''].setValue(item);
            this.getLocationLevelDynamic(item);
          }
        })

      }));
    }
  }
  clearChildLevelsData(location: LocationModel) {
    this.clearChildsRecersion(location.locationLevelID);

  }
  clearChildsRecersion(locationID) {
    let _location = this.locationLevels.filter(a => a.parentID == locationID)[0];
    if (_location != null) {
      _location.locationLevelData = null;
      this.clearChildsRecersion(_location.locationLevelID);
    }
    else {
      return;
    }


  }
  isLocationDropDownSelected(location: LocationModel) {

    if (this.customerProfile != null && this.customerProfile.locationDetails != null) {
      let locationDetails = this.customerProfile.locationDetails;
      let res = locationDetails.filter(a => a.locationLevelID == location.locationLevelID && a.locationID == location.locationID);
      if (res != null && res.length > 0) {
        return true;
      }
    }
    return false;
  }
  getSelectedLevelLocationID(childLevel: LocationLevel) {
    if (this.customerProfile != null && this.customerProfile.locationDetails != null) {
      let locationDetails = this.customerProfile.locationDetails;
      let res = locationDetails.filter(a => a.locationLevelID == childLevel.locationLevelID)[0];
      if (res != null) {
        let location: LocationModel = {
          locationID: res.locationID,
          locationLevelID: res.locationLevelID
        }
        return location;
      }
    }
    return null;
  }


  onSelectFile(event, scopeID, typeID, controlName) {

    if (event.target.files && event.target.files[0]) {


      let obj = this.attachmentIds[controlName];
      if (obj == null) {
        obj = {};
        this.attachmentIds[controlName] = obj;
      }

      var reader = new FileReader();

      let reqModel: AttachmentUploadModel = {
        scopeId: scopeID,
        typeId: typeID,
        formFile: event.target.files[0],
        isIdintity: false,
        customerName: this.customer.customerID,

      }
      let formData = this.attachmentService.modelToFormData(reqModel);
      this.attachmentService.uploadAttachmnet(formData).subscribe(res => {

        // this.profilePicAttachmentId = res['result'];
        let obj = this.attachmentIds[controlName];
        obj['attachmnetID'] = res['result'];
        this.attachmentIds[controlName] = obj;
        let _existAttachmnets = this.existAttachmentIDs.filter(a => a.TypeID == typeID);
        _existAttachmnets.forEach(element => {
          this.attachmentDeleteIds.push(element);
        });

        this.existAttachmentIDs = this.existAttachmentIDs.filter(a => a.TypeID != typeID);
        this.existAttachmentIDs.push({
          AttachmnetID: res['result'],
          TypeID: typeID
        })
        /*     if(_existAttachmnetIndex>-1){
              this.attachmentDeleteIds.push(this.existAttachmentIDs[_existAttachmnetIndex].TypeID);
              this.existAttachmentIDs[_existAttachmnetIndex].AttachmnetID=res['result'];
            } */

      })
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      obj['file'] = event.target.files[0];
      let objectURL = URL.createObjectURL(event.target.files[0]);
      let sanitizedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(objectURL)
      obj['attachmnetLink'] = sanitizedUrl;
      this.attachmentIds[controlName] = obj;
      //this.profilePicFile = event.target.files[0];
      reader.onload = (event) => { // called once readAsDataURL is completed
        //this.profilePicUrl = event.target.result;
        let obj = this.attachmentIds[controlName];
        //obj['attachmnetLink']=event.target.result;
        //this.personalInfoForm.controls[controlName].setValue(obj);
        this.attachmentIds[controlName] = obj;

      }
    }
  }

  validateEndDateAgainstStartDate(startDateControlName): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if(this.personalInfoForm==null||startDateControlName==null||this.personalInfoForm.controls[startDateControlName]){
        return null;
      }
      const startDateControl=this.personalInfoForm.controls[startDateControlName];
      control.value>=startDateControl.value
      ? null : {invalidEndDate: control.value};
    };
  }
}
